/**
 * Parse a query string into a map of keys to values.
 * JSON object/array values (used by Quick Start `action=`) are parsed.
 */
function queryString(string) {
  const keyValues = {}
  const search = string || (typeof window !== 'undefined' ? window.location.search : '')
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)

  for (const [key, value] of params.entries()) {
    keyValues[key] = maybeParseJson(value)
  }

  return keyValues
}

function maybeParseJson(value) {
  if (typeof value !== 'string') return value
  const trimmed = value.trim()
  if (trimmed[0] !== '{' && trimmed[0] !== '[') return value
  try {
    return JSON.parse(trimmed)
  } catch (err) {
    return value
  }
}

export { queryString }
